import { Validator } from "vee-validate"
import zxcvbn from 'zxcvbn';

Validator.extend('password-strength', {
    validate: (value, args) => {
        return zxcvbn(value).score >= args[0];
    },
});
